<template>
<div>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <v-card class="pa-3">
            <div class="mb-5">
                <h2>รายงานสินทรัพย์คงเหลือ</h2>
            </div>
            <div class="list_remaining_asset_report_list justify-space-between">
                <div>
                    <v-card class="pa-3 mb-3">
                        <v-card class="d-flex align-center icon_list_remaining_asset_report_list" color="primary">
                            <v-icon size="40">mdi-cash-multiple</v-icon>
                        </v-card>
                        <div class="text-right">
                            <div>บาท</div>
                            <h3>{{ Intl.NumberFormat().format(capital_sum) }}</h3>
                        </div>
                        <hr>
                        <div>ทุน</div>
                    </v-card>
                </div>
                <div>
                    <v-card class="pa-3 mb-3">
                        <v-card class="d-flex align-center icon_list_remaining_asset_report_list" color="primary">
                            <v-icon size="40">mdi-cash-multiple</v-icon>
                        </v-card>
                        <div class="text-right">
                            <div>บาท</div>
                            <h3>{{ Intl.NumberFormat().format(creditor_sum) }}</h3>
                        </div>
                        <hr>
                        <div>เจ้าหนี้</div>
                    </v-card>
                </div>
                <div>
                    <v-card class="pa-3 mb-3">
                        <v-card class="d-flex align-center icon_list_remaining_asset_report_list" color="primary">
                            <v-icon size="40">mdi-cash-multiple</v-icon>
                        </v-card>
                        <div class="text-right">
                            <div>บาท</div>
                            <h3>{{ Intl.NumberFormat().format(debtor_sum) }}</h3>
                        </div>
                        <hr>
                        <div>ลูกหนี้</div>
                    </v-card>
                </div>
            </div>
            <div class="list_remaining_asset_report_list justify-space-between">
                <div>
                    <v-card class="pa-3 detail_remaining_asset_report_list">
                        <div class="pa-3">
                            <div class="d-flex justify-space-between">
                                <div>#รายการ</div>
                                <div>ยอด</div>
                            </div>
                        </div>
                        <div class="pa-3" v-for="(capital_detail,index) in capital_list" :key="index">
                            <div class="d-flex justify-space-between">
                                <div>{{ capital_detail.capital_name }}</div>
                                <div>{{ Intl.NumberFormat().format(capital_detail.capital_price) }}</div>
                            </div>
                            <hr>
                        </div>
                    </v-card>
                </div>
                <div>
                    <v-card class="pa-3 detail_remaining_asset_report_list">
                        <div class="pa-3">
                            <div class="d-flex justify-space-between">
                                <div>#รายการ</div>
                                <div>ยอด</div>
                            </div>
                        </div>
                        <div class="pa-3" v-for="(creditor_detail,index) in creditor_list" :key="index">
                            <div class="d-flex justify-space-between">
                                <div>{{ creditor_detail.creditor_name }}</div>
                                <div>{{ Intl.NumberFormat().format(creditor_detail.creditor_price) }}</div>
                            </div>
                            <hr>
                        </div>
                    </v-card>
                </div>
                <div>
                    <v-card class="pa-3 detail_remaining_asset_report_list">
                        <div class="pa-3">
                            <div class="d-flex justify-space-between">
                                <div>#รายการ</div>
                                <div>ยอด</div>
                            </div>
                        </div>
                        <div class="pa-3" v-for="(debtor_detail,index) in debtor_list" :key="index">
                            <div class="d-flex justify-space-between">
                                <div>{{ debtor_detail.debtor_name }}</div>
                                <div>{{ Intl.NumberFormat().format(debtor_detail.debtor_price) }}</div>
                            </div>
                            <hr>
                        </div>
                    </v-card>
                </div>
            </div>
        </v-card>

    </div>
</div>
</template>

<script>
import assignrelevantpeopleall from '@/api/account/accountsetting/assignrelevantpeopleall.js'
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: false,
            capital_sum: null,
            capital_list: [],
            creditor_sum: null,
            creditor_list: [],
            debtor_sum: null,
            debtor_list: [],
        }
    },
    methods: {
        async assignRelevantPeople() {
            this.loading_page = true
            assignrelevantpeopleall.assignRelevantPeopleList().then((response) => {
                if (response.data.successful === true) {
                    this.capital_sum = response.data.capitalSum
                    this.capital_list = response.data.capitalList
                    this.creditor_sum = response.data.creditorSum
                    this.creditor_list = response.data.creditorList
                    this.debtor_sum = response.data.debtorSum
                    this.debtor_list = response.data.debtorList
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
    },
    mounted() {
        this.assignRelevantPeople()
    }
}
</script>

<style scoped>
.list_remaining_asset_report_list {
    display: grid;
    grid-template-columns: 30% 30% 30%;
}

.icon_list_remaining_asset_report_list {
    padding: 15px;
    border-radius: 4px !important;
    position: absolute !important;
    top: -22px;
    left: 10px;
}

.icon_list_remaining_asset_report_list>i {
    color: #fff !important;
}

.detail_remaining_asset_report_list {
    height: 100%;
}
</style>
